// extracted by mini-css-extract-plugin
module.exports = {"quota":"component_quota__1Mkvg"};